import { fromDatestampObject } from "./time";
import { MoneyModel } from "./MoneyModel";
import Decimal from 'decimal.js';
import { utils } from "../utils";
export let PayoutSummaryStatus = /*#__PURE__*/function (PayoutSummaryStatus) {
  PayoutSummaryStatus["Paid"] = "Paid";
  PayoutSummaryStatus["Scheduled"] = "Scheduled";
  return PayoutSummaryStatus;
}({});
export class PayoutsSummaryModel {
  static fromPayoutDTO(payout) {
    return {
      date: fromDatestampObject(payout.date),
      amount: MoneyModel.fromDTO(payout.amount),
      id: payout.id,
      status: payout.status
    };
  }
  static fromDTO(dto) {
    return new PayoutsSummaryModel({
      paidThisMonth: MoneyModel.fromDTO(dto.paidThisMonth),
      payouts: (dto.payouts || []).map(PayoutsSummaryModel.fromPayoutDTO).slice(0, 5)
    });
  }
  static makeEmpty() {
    return new PayoutsSummaryModel({
      paidThisMonth: new MoneyModel(new Decimal(0)),
      payouts: []
    });
  }
  constructor(model) {
    this.model = model;
  }
  formattedPaidThisMonth() {
    return utils.formatDollarAmount(this.model.paidThisMonth.amount());
  }
  formattedFuturePayouts() {
    const totalFuturePayouts = this.model.payouts.filter(p => p.status === PayoutSummaryStatus.Scheduled).reduce((acc, curr) => acc.add(curr.amount.amount()), new Decimal(0));
    return utils.formatDollarAmount(totalFuturePayouts);
  }
  isEmpty() {
    return this.model.payouts.length === 0;
  }
  hasPaidPayouts() {
    return this.model.payouts.some(p => p.status === PayoutSummaryStatus.Paid);
  }
  addPayouts(payouts) {
    return new PayoutsSummaryModel({
      paidThisMonth: payouts.reduce((acc, curr) => acc.add(curr.amount.amount()), this.model.paidThisMonth),
      payouts: [...this.model.payouts, ...payouts]
    });
  }
  payouts() {
    return this.model.payouts;
  }
  mapPayouts(fn) {
    return this.model.payouts.map((payout, idx) => {
      const isLast = idx === this.model.payouts.length - 1;
      return fn(payout, idx, isLast);
    });
  }
}